<template>
  <div class="data-management-page">
    <div v-if="!isOfficeAdmin" class="restricted-message">
      This page is restricted to Office Admins.
    </div>
    <template v-else>
      <h1>Data Management</h1>
      <p class="page-intro">Tools for cleaning up and maintaining the underlying data. More tools land here over time.</p>

      <div class="collapsible-section">
        <div class="header" @click="isDuplicatesCollapsed = !isDuplicatesCollapsed">
          <h2>Duplicate Guest Review</h2>
          <span>{{ isDuplicatesCollapsed ? '▼' : '▲' }}</span>
        </div>
        <div v-if="!isDuplicatesCollapsed" class="content">
          <DuplicateGuestReview />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import DuplicateGuestReview from "./DuplicateGuestReview.vue";

export default {
  name: "DataManagement",
  components: { DuplicateGuestReview },
  data() {
    return {
      isDuplicatesCollapsed: false,
    };
  },
  computed: {
    // The nav link that gets here is already admin-only (App.vue) and every API call
    // this page makes is enforced server-side too - this is just so a direct URL
    // visit by a non-admin shows a clean message instead of a page full of 401s.
    isOfficeAdmin() {
      return sessionStorage.getItem('role') === 'admin';
    },
  },
};
</script>

<style scoped>
.data-management-page {
  padding-bottom: 40px;
}

.page-intro {
  color: #666;
  margin-bottom: 20px;
}

.collapsible-section {
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
}

.header {
  background-color: #f5f5f5;
  padding: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.content {
  padding: 15px;
}

.restricted-message {
  padding: 20px;
  background-color: #f8d7da;
  color: #721c24;
  border-radius: 5px;
}
</style>
